import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { NumberField, SelectField } from 'react-admin';

import { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';
import thresholdModes, { thresholdModeChoices } from '../../../constants/thresholdModes';
import { timePeriodChoices } from '../../../constants/timePeriods';
import { priorityChoices } from '../../../constants/thresholdPriorities';
import { ThresholdField } from './AmountThreshold';
import TransactionTypeConfigurationField from '../../../customFields/TransactionTypeConfigurationField';
import { Rule } from '../../../utilities/schemas/rules';

const TransactionThreshold = ({ rule }: { rule: Rule }) => {
  const thresholdMode = rule?.ruleParameters?.thresholdMode;

  const showDefault = thresholdMode === thresholdModes.DEFAULT_ONLY
    || thresholdMode === thresholdModes.BOTH;
  const showForm = thresholdMode === thresholdModes.KYC_ONLY
    || thresholdMode === thresholdModes.BOTH;
  const showPriority = thresholdMode === thresholdModes.BOTH;

  return (
    <Grid
      alignItems="baseline"
      size={{
        xs: 12,
        sm: 6,
        lg: 4,
      }}
    >
      <Box display="flex" flexDirection="row" gap={1} alignItems="baseline" flexWrap="wrap">
        <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
          Transaction types configuration
        </Typography>
        <TransactionTypeConfigurationField
          source="ruleParameters.transactionTypeConfiguration"
          sx={{ fontSize: 10 }}
        />

        <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
          Transaction monitoring mode
        </Typography>
        <SelectField
          choices={transactionMonitoringModesChoices}
          source="ruleParameters.transactionMonitoringMode"
          sx={{ fontSize: 10 }}
        />

        <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
          Threshold mode
        </Typography>
        <SelectField
          choices={thresholdModeChoices}
          source="ruleParameters.thresholdMode"
          sx={{ fontSize: 10 }}
        />

        {showDefault && (
          <>
            <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
              Default threshold
            </Typography>
            <ThresholdField source="ruleParameters.default" fontSize={10} />
          </>
        )}

        {showForm && (
          <>
            <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
              KYC form threshold
            </Typography>
            <ThresholdField source="ruleParameters.form" fontSize={10} unit="%" />

            <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
              KYC form max age
            </Typography>
            <NumberField
              source="ruleParameters.kycFormDataMaxAge"
              options={{ style: 'unit', unit: 'day', unitDisplay: 'long' }}
              sx={{ fontSize: 10 }}
            />
          </>
        )}

        {showPriority && (
          <>
            <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
              Threshold priority
            </Typography>
            <SelectField
              source="ruleParameters.parameterPriority"
              choices={priorityChoices}
              sx={{ fontSize: 10 }}
            />
          </>
        )}

        <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
          Period
        </Typography>
        <NumberField source="ruleParameters.period.amount" sx={{ fontSize: 10 }} />
        <SelectField source="ruleParameters.period.unit" choices={timePeriodChoices} sx={{ fontSize: 10 }} />
      </Box>
    </Grid>
  );
};

export default TransactionThreshold;
